import React, { useState } from "react";
import { Tooltip } from "@/components/common/Tooltip";

interface TruncatedTextProps {
  children: React.ReactNode;
  tooltip?: string;
  className?: string;
  /** When true, the tooltip shows even if the text isn't overflowing —
   * for cases where the tooltip carries information beyond the visible
   * label (e.g. an explanation of a placeholder name). */
  alwaysShow?: boolean;
  "data-testid"?: string;
}

export const TruncatedText: React.FC<TruncatedTextProps> = ({
  children,
  tooltip,
  className,
  alwaysShow = false,
  "data-testid": dataTestId,
}) => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const title = tooltip ?? (typeof children === "string" ? children : "");
  const shouldShow = alwaysShow || isOverflowing;
  return (
    <Tooltip title={shouldShow ? title : ""}>
      <span
        data-testid={dataTestId}
        className={`truncate ${className ?? ""}`}
        onMouseEnter={(e) =>
          setIsOverflowing(
            e.currentTarget.scrollWidth > e.currentTarget.clientWidth,
          )
        }
      >
        {children}
      </span>
    </Tooltip>
  );
};
